import { Button, Modal, ModalClose, ModalDialog, Stack, Typography } from '@healthinal/ui';
import type { IPersonListItem } from '../../../api/generated/person-controller/person-controller';
import { TypographyLink } from '../../../components/TypographyLink';

const confirmationMessages = {
  create:
    'Bist du sicher, dass du diese Person anlegen möchtest? Es existiert bereits eine Person mit dem gleichen Vor-, Nachnamen und Geburtsdatum',
  update:
    'Bist du sicher, dass du diese Änderungen speichern möchtest? Es existiert bereits eine andere Person mit dem gleichen Vor-, Nachnamen und Geburtsdatum',
} as const;

export function DuplicatePersonConfirmationModal({
  open,
  loading,
  mode = 'create',
  persons,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  loading?: boolean;
  mode?: 'create' | 'update';
  persons: IPersonListItem[];
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
}) {
  return (
    <Modal open={open} onClose={onCancel}>
      <ModalDialog sx={{ width: 500 }}>
        <ModalClose />
        <Typography level="h4">Doppelte Person gefunden</Typography>
        <Stack gap={2}>
          <Typography>{confirmationMessages[mode]}</Typography>

          <Stack gap={0.5}>
            {persons.map((person) => (
              <TypographyLink key={person.id} href={`/masterdata/persons/${person.id}`} target="_blank" level="body-sm">
                {person.firstName} {person.lastName}
              </TypographyLink>
            ))}
          </Stack>

          <Stack direction="row" justifyContent="flex-end" gap={2} mt={1}>
            <Button variant="outlined" color="neutral" onClick={onCancel}>
              Nein
            </Button>
            <Button loading={loading} onClick={onConfirm}>
              Ja
            </Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
